module.exports = __webpack_public_path__ + "img/3.0bc0b7a6.png";